import axios from "axios";
import { getApiBaseUrl } from "../config";
const service = axios.create({
    baseURL: "http://localhost:4500/",
    // timeout,
    // withCredentials
});

export default {
    async uploadImage(formData) {
        const response = await service.post(
            `${getApiBaseUrl()}common/upload/image`,
            formData
        );
        return response;
    },
    async uploadFile(formData) {
        const response = await service.post(
            `${getApiBaseUrl()}common/upload/file`,
            formData
        );
        return response;
    },
};
